div.ciqa-banner{
    width: 100%;
        height: 130px;
        overflow: hidden;
        // background: #08152c;
        background: linear-gradient(#e0e5fb, #f5f7ff);


        ul, li{
            padding: 0px;
            margin: 0px;
        }

        ul{
            max-width: 1200px;
            margin: 0px auto 0px;
        }

        li{
            width: 33.33%;
            margin-top: 0px;
            height: 120px;
            overflow: hidden;
            display: inline-block;
            box-sizing: border-box;
            padding: 5px;
            position: relative;
            transition: all .5s;
            img{
                width: 100%;
                box-sizing: border-box;
                box-shadow: 0 0 10px rgba(0,0,0,.1);
                border: 1px solid rgba(0,0,0,.0);
                // filter: grayscale(.7);
                &:hover{
                    filter: grayscale(.0);
                }
            }

            h4{
                position: absolute;
                width: 100%;
                height: 40px;
                top: 115px;
                margin:0px;
                display: none;

                a{
                    background: rgba(0,0,0,.7);
                    color: #fff;
                    display: block;
                    width: 100%;
                    padding: 10px;
                    box-sizing: border-box;
                }
            }

            &:nth-child(1) {
                transform: scale(1.03);
                // filter: blur(1px);
                opacity: .9;
            }

            &:nth-child(2) {
                transform: scale(1.03);
            }

            &:nth-child(3) {
                transform: scale(1.03);
                // filter: blur(1px);
                opacity: .9;
            }

            &:hover{
                transform: scale(1.0);
                // filter: blur(0px);
            }
        }

        span.handler{
            position: absolute;
            margin-top: -25px;
            z-index: 50;
            left: 50%;
            margin-left: -100px;
            i{
                width: 10px;
                height: 10px;
                background: rgba(255,255,255,.8);
                border-radius: 10px;
                display: inline-block;
                margin: 0px 5px;
                cursor: pointer;
                transition: all .5s;

                &:hover, &.active{
                    background: #c42307;
                    transform: scale(1.4);
                }
            }
        }
}